import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import AnalyticsDrilldownModal from "./AnalyticsDrilldownModal";

if (typeof Highcharts === "object") {
    // Handling different import behaviors (ESM vs CJS)
    if (typeof HighchartsDrilldown === "function") {
        HighchartsDrilldown(Highcharts);
    } else if (HighchartsDrilldown && typeof HighchartsDrilldown.default === "function") {
        HighchartsDrilldown.default(Highcharts);
    }
}

const ReopenedAnalysisChart = ({ data, filters }) => {
    const [drilldownInfo, setDrilldownInfo] = useState({ isOpen: false, employeeName: null, title: "" });

    if (!data) return <div>Loading Analytics...</div>;

    const { employee_stats, total_reopened, percent_repeat } = data;

    // Prepare chart data
    const employeeSeriesData = employee_stats.map(emp => ({
        name: emp.name,
        y: parseInt(emp.value, 10),
    }));

    const options = {
        chart: { type: 'column' },
        title: { text: 'Reopened Ticket Analysis by Employee' },
        subtitle: { text: `Total Reopened: <b>${total_reopened}</b> | Repeat Rate: <b>${percent_repeat}%</b><br/><span style="color: #666">Click on bars to see ticket details</span>` },
        xAxis: { type: 'category' },
        yAxis: { title: { text: 'Reopened Tickets Handled' } },
        legend: { enabled: false },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: { enabled: true, format: '{point.y}' },
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            setDrilldownInfo({
                                isOpen: true,
                                employeeName: this.name,
                                title: `Reopened Tickets for ${this.name}`
                            });
                        }
                    }
                }
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> tickets<br/>'
        },
        series: [
            {
                name: "Employees",
                colorByPoint: true,
                data: employeeSeriesData
            }
        ],
        credits: { enabled: false }
    };

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md">
            <HighchartsReact highcharts={Highcharts} options={options} />
            {/* KPI Section */}
            <div className="mt-4 grid grid-cols-2 gap-4 text-center">
                <div className="p-4 bg-red-50 rounded-xl">
                    <p className="text-sm text-gray-500">Total Reopened Tickets</p>
                    <p className="text-2xl font-bold text-red-600">{total_reopened}</p>
                </div>
                <div className="p-4 bg-orange-50 rounded-xl">
                    <p className="text-sm text-gray-500">% Repeat Errors</p>
                    <p className="text-2xl font-bold text-orange-600">{percent_repeat}%</p>
                </div>
            </div>

            <AnalyticsDrilldownModal
                isOpen={drilldownInfo.isOpen}
                onClose={() => setDrilldownInfo({ ...drilldownInfo, isOpen: false })}
                title={drilldownInfo.title}
                type="reopened"
                employeeName={drilldownInfo.employeeName}
                filters={filters}
            />
        </div>
    );
};

export default ReopenedAnalysisChart;
